const fieldTypes = [
  "text",
  "number",
  "password",
  "select",
  "multiselect",
  "switch",
  "textarea",
  "file",
  "multifile",
  "certificate"
];

export default fieldTypes;



// WEBPACK FOOTER //
// ./src/Utils/field-types.js